import React from 'react';
import { SmilePlus } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { OPEN_FEEDBACK_MODAL_EVENT } from './RatingModal';

export default function FeedbackHeaderCTA() {
  const { isDark } = useTheme();

  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new CustomEvent(OPEN_FEEDBACK_MODAL_EVENT))}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        borderRadius: 999,
        border: isDark ? '1px solid rgba(245,158,11,0.35)' : '1px solid rgba(37,99,235,0.24)',
        background: isDark ? 'rgba(245,158,11,0.1)' : 'rgba(37,99,235,0.08)',
        color: isDark ? '#FCD34D' : '#1d4ed8',
        padding: '5px 10px',
        cursor: 'pointer',
        lineHeight: 1.1,
        transition: 'all 0.18s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-1px)';
        e.currentTarget.style.filter = 'brightness(1.05)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.filter = 'none';
      }}
      aria-label="Share feedback"
      title="Share your thoughts"
    >
      <SmilePlus size={14} />
      <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <span style={{ fontSize: 12, fontWeight: 800 }}>Is this helpful?</span>
        <span style={{ fontSize: 10, opacity: 0.85 }}>Share your thoughts</span>
      </span>
    </button>
  );
}
